import * as Yup from "yup";
import AutoCompleteFormControl from "../../../components/formcontrols/AutoCompleteFormControl";
import ValidationErrorMessage from "../../../components/formcontrols/ValidationErrorMessage";
import { getPatchOperations } from "../../../util/form";

export const personInteresseForm = (
  queryValues: IFormControlGenericQueryValues,
  personId: string,
  interesse?: { id: string; interesseId: string },
): FormConfig<PersonInteresseDTO> => {
  return {
    title: "interesseområde",
    lockedValues: [
      {
        id: "personId",
        value: personId,
      },
      {
        id: "interesseId",
        value: interesse?.interesseId,
      },
    ],
    form: [
      {
        component: "custom",
        customComponent: ({ touched, value, error, onChange }) => {
          return (
            <>
              <label className="form-label">Interesse</label>
              <AutoCompleteFormControl
                className={touched && error ? "is-invalid" : ""}
                onChange={onChange}
                value={value}
                queryValues={queryValues}
              />
              <ValidationErrorMessage touched={touched} errorMessage={error} />
            </>
          );
        },
        id: "interesseId",
        label: "Interesse",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      interesseId: Yup.string().required("Interesse skal være sat"),
    }),
    get: `person/${personId}/interesser/${interesse?.id}`,
    patch: (values: PersonInteresseDTO) => {
      return {
        query: `person/${personId}/interesser/${interesse?.id}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    post: (values: PersonInteresseDTO) => {
      return {
        query: `person/${personId}/interesser`,
        body: values,
      };
    },
    delete: () => {
      return {
        query: `person/${personId}/interesser/${interesse?.id}`,
      };
    },
  };
};
